import { yupLocalized } from "@ryde/shared";

export const bulkJourneyAssignFormValidationRules = {
  journeyId: yupLocalized.number().required(),
};
